<div class="p-1 z-0" *ngIf="routeCurrent.bkRouteC">
  <h5 *ngIf="showUser">{{ 'h5.user' | translate }} : {{routeCurrent.user}}</h5>
  <h5>{{ 'h5.load' | translate }}: {{routeCurrent.bkLoadR}}</h5>

  <h5>{{ 'h5.route' | translate }}: {{routeCurrent.bkRouteC}}</h5>
  <div class="weight-info">
    <h5>{{ 'h5.vol' | translate }}: {{routeCurrent.vol}}</h5>
    <h5 *ngIf="routeCurrent.isVisibleWeight">{{ 'h5.totalWeight' | translate }}: {{routeCurrent.totalGrossWeightA}} Kg</h5>
  </div>
  <!-- <h5>{{ 'h5.modal' | translate }} : {{ 'h5.transportmodal.' + routeCurrent.transportModalF | translate }}</h5> -->
</div>
